<div class="p-field">
  <label for="valuta-select" kodit-form-label>Valuta</label>
  <kodit-valuta-dropdown
    [valutaCtrl]="valutaCtrl"
    (onValutaChanged)="handleValutaChanged($event)"
  ></kodit-valuta-dropdown>
</div>
